import Counter from "./Counter";

function About() {
  return (
    <div className="about-section">
      <div className="about-content">
        <div style={{ textAlign: "center", margin: "40px 0" }}>
          <h3 style={{ fontFamily: "ChickenCrispy", fontSize: "30px" }}>
            Events Captured
          </h3>
          <Counter start={600} end={1000} duration={4000} />
        </div>

        <h2>About Us</h2>
        <p>
          Welcome to our photography studio! We are located in Velacherry,
          Chennai-42.
          <br /> We are passionate about capturing life's beautiful moments
          through our lens. Our team of talented photographers is dedicated to
          providing you with stunning images that you'll cherish forever.
        </p>
        <p>
          Thank you for considering us to capture your special moments. We look
          forward to working with you and creating memories that will last a
          lifetime.
        </p>

        <h2>Our Services</h2>
        <h3>Candid Photography</h3>
        <p>
          Capture natural emotions, smiles, and moments as they happen.
          Unscripted, timeless, and authentic.
        </p>

        <h3>Traditional Wedding Photography</h3>
        <p>
          From rituals to blessings, we preserve every sacred moment with a
          traditional and elegant touch.
        </p>

        <h3>Wedding Films</h3>
        <p>
          Your story deserves to be told like a movie. We create cinematic
          wedding films that beautifully blend storytelling and emotions.
        </p>

        <h3>Couple Portraits</h3>
        <p>
          Whether it's a pre-wedding shoot or romantic portraits, we capture the
          chemistry and bond you share with creative frames.
        </p>

        <h3>Maternity Photography</h3>
        <p>
          Celebrate the journey of motherhood with soulful maternity portraits
          that you’ll treasure forever.
        </p>

        <h3>Baby & Kids Photography</h3>
        <p>
          Every giggle and milestone deserves to be remembered. We specialize in
          newborn, toddler, and kids’ shoots.
        </p>

        <h3>Outdoor Photoshoots</h3>
        <p>
          From serene beaches to vibrant parks, our outdoor sessions make the
          most of natural beauty with you at the center.
        </p>

        <h2>Special Occasions Covered</h2>
        <p>
          We cover all your memorable events with utmost care and creativity:
        </p>
        
          <p>Sangeet & Mehendi</p>
          <p>Receptions</p>
          <p>Birthdays & Anniversaries</p>
          <p>Other Family Functions & Gatherings</p>
        

        <h2>Where We Work</h2>
        <p>
          We proudly serve clients across all major cities in South India,
          including Chennai, Bangalore, Hyderabad, Coimbatore, Kochi, Madurai,
          and more.
        </p>

        <h2>Customized Packages</h2>
        <p>
          Every event is unique, and so should be your photography package. We
          offer:
        </p>
          <p>Tailored packages for weddings, portraits, and events</p>
          <p>Flexible pricing to suit different budgets</p>
          <p>Combo packages with photography and cinematic films</p>
      </div>
    </div>
  );
}

export default About;
